// https://vuex.vuejs.org/en/getters.html

export default {
  getTotalItems: (state) => state.totalItems,
  getTotalHold: (state) => state.totalHold,
  getTotalApproved: (state) => state.totalApproved
}
